/* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */
import React, { useRef, useLayoutEffect } from 'react';

import { evalLegacyConnectInlineScripts } from '@confluence/connect-utils';
import { fg } from '@confluence/feature-gating';

type WebPanelProps = {
	html: string;
};

export function WebPanel({ html }: WebPanelProps) {
	const containerRef = useRef<HTMLDivElement>(null);

	useLayoutEffect(() => {
		const container = containerRef.current;
		if (!container) return;

		// This is essentially a bug in React hydration. It is supposed to replace the element content with dangerouslySetInnerHTML
		// when server rendered output differs from client rendered output, but in reality it is keeping the original content.
		// Since it is keeping the original content, we need to manually check for the iframe and skip evalLegacyConnectInlineScripts
		// to avoid destroying / creating another iframe for connect webpanels.
		if ((window as any)?.__HYDRATABLE__ && fg('content_early_connect_iframe_initialization')) {
			const scriptElement = container.querySelector('script.ap-iframe-body-script');
			if (scriptElement) {
				const scriptContent = scriptElement.textContent || '';
				const match = scriptContent.match(/"uniqueKey":"([^"]+)"/);
				if (match) {
					const uniqueKey = match[1];
					// Find iframe whose id contains the uniqueKey
					const iframe = container.querySelector(`iframe[id*="${uniqueKey}"]`);
					if (iframe) {
						return;
					}
				}
			}
		}

		void evalLegacyConnectInlineScripts(container);
	}, [html]);

	return <div ref={containerRef} dangerouslySetInnerHTML={{ __html: html }} />;
}
